import React from 'react';
import { NCZIPreferredHealthProfessional } from '../../../../Interfaces/ncziPatientInformations';
import ElectronicHealthCardContactInfoPreferredHealthProfessional from './ElectronicHealthCardContactInfoPreferredHealthProfessional';
// @ts-ignore
import styles from './ElectronicHealthCardContactInfoPreferredHealthProfessionals.module.scss';
import LinkButton from '../../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../../Enums/Theme.enum';
import ScrollContainer from '../../../../../Base/Components/ScrollContainer';

interface Props {
	healthProfessionals: NCZIPreferredHealthProfessional[];
	patientIdentifier: string;
	handleReloadData?: () => void;
	handleAdd: () => void;
}

const ElectronicHealthCardContactInfoPreferredHealthProfessionals: React.FC<
	Props
> = ({
	healthProfessionals,
	patientIdentifier,
	handleReloadData,
	handleAdd,
}) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.controls}>
				<LinkButton
					title={'Přidat zdravotníka'}
					theme={Theme.BLUE}
					onClick={() => handleAdd()}
				/>
			</div>
			<ScrollContainer>
				<div className={styles.content}>
					{healthProfessionals.map(healthProfessional => (
						<ElectronicHealthCardContactInfoPreferredHealthProfessional
							key={healthProfessional.rcId}
							healthProfessional={healthProfessional}
							patientIdentifier={patientIdentifier}
							handleReloadData={handleReloadData}
						/>
					))}
				</div>
			</ScrollContainer>
		</div>
	);
};

export default ElectronicHealthCardContactInfoPreferredHealthProfessionals;
